import { useState } from 'react';
import {
  GridColumnVisibilityModel,
  GridFilterModel,
  GridPinnedColumnFields,
  GridSortModel,
} from '@spotgamma/x-data-grid-premium';
import { defaultColumnScannerVisibility, scannerFields } from 'config';
import { EquityFieldKey } from 'types';

export interface ScannerGridStateSnapshot {
  useDefaultColumns?: boolean;
  columnVisibilityModel?: GridColumnVisibilityModel;
  pinnedColumns?: GridPinnedColumnFields;
  sortModel?: GridSortModel;
  filterModel?: GridFilterModel;
  columnOrder?: EquityFieldKey[];
  activeWatchlistIds?: number[];
}

export function useScannerGridState(initial?: ScannerGridStateSnapshot) {
  const [useDefaultColumns, setUseDefaultColumns] = useState(
    initial?.useDefaultColumns ?? true,
  );
  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>(
      initial?.columnVisibilityModel ?? defaultColumnScannerVisibility,
    );
  const [pinnedColumns, setPinnedColumns] = useState<GridPinnedColumnFields>(
    initial?.pinnedColumns ?? {
      left: ['isWatchlisted', 'sym'],
      right: [],
    },
  );
  const [sortModel, setSortModel] = useState<GridSortModel>(
    initial?.sortModel ?? [],
  );
  const [filterModel, setFilterModel] = useState<GridFilterModel | undefined>(
    initial?.filterModel ?? undefined,
  );
  const [columnOrder, setColumnOrder] = useState<EquityFieldKey[]>(
    initial?.columnOrder ?? scannerFields,
  );
  const [activeWatchlistIds, setActiveWatchlistIds] = useState<number[]>(
    initial?.activeWatchlistIds ?? [],
  );

  return {
    useDefaultColumns,
    setUseDefaultColumns,
    columnVisibilityModel,
    setColumnVisibilityModel,
    pinnedColumns,
    setPinnedColumns,
    sortModel,
    setSortModel,
    filterModel,
    setFilterModel,
    columnOrder,
    setColumnOrder,
    activeWatchlistIds,
    setActiveWatchlistIds,
  };
}
